import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'

export default class DirectDeposit extends BasePaymentMethod{
  constructor (payment) {
    super(payment)
    this.displayName = 'Direct Deposit'
  }

  eligible () {
    return this.payment.booking.booking.paymentMethods.directDeposit
  }

  renderTermsAndConditions () {
    return this.payment.renderTermsAndConditions()
  }

  render () {
    return <div class='o-accent-box'>
      { this.payment.renderPaymentMethodSelection() }
      <div class='direct-deposit-info'>
        <div class='o-inner-accent-box bank-details'>
          <div class='bank-details__account-name'>
            <h3 class='compact-label'>Bank account name</h3>
            <div class='bank-details__info'>{this.payment.config.bankDetails.accountName}</div>
          </div>

          <div class='bank-details__bsb-number'>
            <h3 class='compact-label'>BSB Number</h3>
            <div class='bank-details__info'>{this.payment.config.bankDetails.bsbNumber}</div>
          </div>

          <div class='bank-details__account-number'>
            <h3 class='compact-label'>Account Number</h3>
            <div class='bank-details__info'>{this.payment.config.bankDetails.accountNumber}</div>
          </div>
        </div>
        <div class='o-inner-accent-box'>
          <div class='message-info'>
          Your bank may allow you to pay for your trip by bank transfer, either over the phone or online. Please make a note of our account details so that you have them to hand when making your payment. You may also be asked for a payment reference - please use your booking reference number; this can be found in the confirmation email that you will receive shortly after completing your booking.
          </div>
        </div>
      </div>
    </div>
  }

  book () {
    return this.payment.booking.payWithDirectDeposit(this.payment.calculatePaymentAmount())
  }

  renderPaymentSummary () {
    return [
      this.payment.renderPaymentAmount(),
      <button type='submit' class='btn-primary pay-now-btn'>Book Now</button>,
    ]
  }
}
